<template>
  <div class="b-destination-card">
    <div class="b-destination-card__picture">
      <Anchor v-if="item.link" :item="item.link" :hide-text="true">
        <LazyImage v-if="item.image" :image="item.image" class="city-image" />
      </Anchor>
      <div v-else>
        <LazyImage v-if="item.image" :image="item.image" class="city-image" />
      </div>
    </div>
    <div class="b-destination-card__title">
      <div class="bold h3">{{ item.title }}</div>
    </div>
    <div
      v-if="item.summary"
      class="b-destination-card__description p"
      v-html="item.summary"></div>

    <div class="b-destination-card__footer">
      <div v-if="item.places" class="mb-30">
        <div class="bold">{{ dictionary.placesLabel }} {{ item.places }}</div>
      </div>

      <Anchor
        v-if="item.link"
        :item="item.link"
        :hide-text="true"
        class="btn btn-link btn-icon-end btn-forward">
        <strong>{{ item.link?.text }}</strong>
        <i class="icon-arrow-long-right"></i>
      </Anchor>
    </div>
  </div>
</template>

<script>
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'

export default {
  components: { Anchor, LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
